import {Injectable} from '@angular/core'
import {Subject} from 'rxjs'
import {AppNotification} from '@core/models/app-notification.model'

@Injectable({providedIn: 'root'})
export class NotificationService {
  private readonly _notification = new Subject<AppNotification>()

  public readonly notification$ = this._notification.asObservable()

  public sendNotification(notification: AppNotification): void {
    this._notification.next(notification)
  }
}
